import { defineMessages } from 'react-intl';

export default defineMessages({
	heading: {
		id: 'discountLanding.unlock.heading',
		defaultMessage: 'Unlock everything with Calm Premium',
		description: 'Heading for Calm Premium feature set section',
	},
	subheading: {
		id: 'discountLanding.unlock.subheading',
		defaultMessage: 'A host of content, tools, and resources to build your mental fitness.',
		description: 'Subheading for Calm Premium feature set section',
	},
	basicHeading: {
		id: 'discountLanding.unlock.basicHeading',
		defaultMessage: 'Basic',
		description: 'Heading for basic features column',
	},
	premiumHeading: {
		id: 'discountLanding.unlock.premiumHeading',
		defaultMessage: 'Premium',
		description: 'Heading for premium features column',
	},
	limitedText: {
		id: 'discountLanding.unlock.limitedText',
		defaultMessage: 'Limited',
		description: 'Text for "limited"',
	},
	unlimitedText: {
		id: 'discountLanding.unlock.unlimitedText',
		defaultMessage: 'Unlimited',
		description: 'Text for "unlimited"',
	},
	limitedTimeOfferText: {
		id: 'discountLanding.unlock.limitedTimeOfferText',
		defaultMessage: 'With this limited time offer:',
		description: 'Discount cta',
	},
	feature1: {
		id: 'discountLanding.unlock.feature1',
		defaultMessage: 'Access to great content',
		description: 'Feature of Calm',
	},
	feature2: {
		id: 'discountLanding.unlock.feature2',
		defaultMessage: 'Hundreds of guided meditations',
		description: 'Feature of Calm',
	},
	feature3: {
		id: 'discountLanding.unlock.feature3',
		defaultMessage: 'Soothing Sleep Stories',
		description: 'Feature of Calm',
	},
	feature4: {
		id: 'discountLanding.unlock.feature4',
		defaultMessage: 'Exclusive music for focus, relaxation, and sleep',
		description: 'Feature of Calm',
	},
	feature5: {
		id: 'discountLanding.unlock.feature5',
		defaultMessage: 'Calming nature sounds',
		description: 'Feature of Calm',
	},
	feature6: {
		id: 'discountLanding.unlock.feature6',
		defaultMessage: 'Gratitude and mood check-ins',
		description: 'Feature of Calm',
	},
	feature7: {
		id: 'discountLanding.unlock.feature7',
		defaultMessage: 'Masterclasses on peak performance',
		description: 'Feature of Calm',
	},
	feature8: {
		id: 'discountLanding.unlock.feature8',
		defaultMessage: 'Lullabies and Sleep Stories for kids',
		description: 'Feature of Calm',
	},
	feature9: {
		id: 'discountLanding.unlock.feature9',
		defaultMessage: 'New content every week',
		description: 'Feature of Calm',
	},
	cta: {
		id: 'discountLanding.unlock.cta',
		defaultMessage: 'Get Calm Premium',
		description: 'Button copy leading user to payment page',
	},
	unlocked: {
		id: 'discountLanding.unlock.unlocked',
		defaultMessage: 'Unlocked',
		description: 'Aria label for a cell with a checkmark',
	},
	locked: {
		id: 'discountLanding.unlock.locked',
		defaultMessage: 'Locked',
		description: 'Aria label for a cell with no checkmark',
	},
	originalPriceLabel: {
		id: 'discountLanding.unlock.originalPriceLabel',
		defaultMessage: 'Original Price',
		description: 'Aria label for a cell with no checkmark',
	},
	discountPriceLabel: {
		id: 'discountLanding.unlock.discountPriceLabel',
		defaultMessage: 'Discounted Price',
		description: 'Aria label for a cell with no checkmark',
	},
});
